import { Injectable, OnDestroy } from '@angular/core';
import { AuthStore } from './stores/auth-store';
import { devLog } from '@app/core/utils/dev-logger';

@Injectable({ providedIn: 'root' })
export class SessionActivityService implements OnDestroy {
  private timer?: number;
  private eventListeners: (() => void)[] = [];

  constructor(private authStore: AuthStore) {
    // Detecta actividad y refresca token si es necesario
    const handler = () => {
      // Only handle activity if authenticated (not locked or unauthenticated)
      const authState = this.authStore.authState();
      if (authState === 'authenticated') {
        this.onUserActivity();
      } else {
        // If not authenticated or locked, clear any pending timer
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = undefined;
        }
      }
    };
    const events = ['click', 'keydown', 'mousemove', 'touchstart'];

    events.forEach(eventName => {
      window.addEventListener(eventName, handler);
      // Store cleanup function
      this.eventListeners.push(() => window.removeEventListener(eventName, handler));
    });
  }

  ngOnDestroy() {
    // Clear timeout
    if (this.timer) {
      clearTimeout(this.timer);
    }

    // Remove all event listeners
    this.eventListeners.forEach(cleanup => cleanup());
    this.eventListeners = [];
  }

  private onUserActivity() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    // If not authenticated, do nothing
    if (this.authStore.authState() !== 'authenticated') return;

    // Wait 1s to debounce multiple activity events, then check token
    this.timer = setTimeout(async () => {
      // Check if token will expire soon (< 5 minutes) and refresh if needed
      const token = this.authStore.token();
      if (token && this.authStore.willExpireSoon(token, 300)) {
        devLog('🔄 SessionActivity: Token expiring soon, refreshing...');
        await this.authStore.refreshIfExpiringSoon();
      }
    }, 1000) as unknown as number;
  }
}
